import { useCallback, useEffect, useMemo, useState } from 'react';
import { getCampaignPool, invalidateCampaignPool } from '../api/campaigns';

const PAGE_SIZE = 20;

/** 마감이 가까운 순. 마감된 건 뒤로 보낸다. */
function byDeadline(a, b) {
  const aClosed = a.status === 'COMPLETED';
  const bClosed = b.status === 'COMPLETED';
  if (aClosed !== bClosed) return aClosed ? 1 : -1;
  const av = a.recruitEnd ? new Date(a.recruitEnd).getTime() : Infinity;
  const bv = b.recruitEnd ? new Date(b.recruitEnd).getTime() : Infinity;
  return av - bv;
}

/**
 * 체험단 목록 피드.
 * 전체를 한 번 받아 마감 임박순으로 정렬한 뒤,
 * '더 보기'를 누를 때마다 PAGE_SIZE씩 노출한다.
 */
export function useCampaignFeed() {
  const [pool, setPool] = useState([]);
  const [status, setStatus] = useState('loading'); // loading | ready | error
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  const load = useCallback(({ fresh = false } = {}) => {
    let cancelled = false;
    if (fresh) invalidateCampaignPool();
    setStatus('loading');
    getCampaignPool()
      .then((list) => { if (!cancelled) { setPool(list); setStatus('ready'); } })
      .catch(() => { if (!cancelled) setStatus('error'); });
    return () => { cancelled = true; };
  }, []);

  useEffect(load, [load]);

  const results = useMemo(() => [...pool].sort(byDeadline), [pool]);

  const items = useMemo(() => results.slice(0, visibleCount), [results, visibleCount]);
  const hasMore = visibleCount < results.length;
  const loadMore = useCallback(() => setVisibleCount((n) => n + PAGE_SIZE), []);

  return {
    items,
    count: results.length,   // 빈 상태 판단용
    status,
    hasMore,
    loadMore,
    retry: () => load({ fresh: true }),
    pageSize: PAGE_SIZE,
  };
}
